module.exports = __webpack_public_path__ + "static/media/c.00a20292.JPG";